import { AllSearchData, emptySearchFiltersAndResults, useDoSearch, useDataForFilters, useTriggerSearch, immediateSearch, submitSearch } from "@me8eon/search";
import React, { useEffect, useMemo } from "react";
import { searchTextName } from "@me8eon/searchtext_filters";
import { filterValuesThatCauseSubmit, useFilterPlugins, useGuiFilters } from "@me8eon/filters";
import { useDebug } from "@me8eon/debug";
import { searchDebugName } from "@me8eon/filter_data_widget";
import { useSelectedDataView } from "@me8eon/data_view_filter";
import { cleanFilters } from "@me8eon/all_filters";

export type AllSearchTypes = "submit" | "immediate" | "aiAssistant" | "aggregations" | "generateFilterFromData"

export function emptySearchData<Filters>(filters: Filters): AllSearchData<AllSearchTypes, any, any, any, any> {
    return {
        submit: emptySearchFiltersAndResults(filters),
        immediate: emptySearchFiltersAndResults(filters),
        aiAssistant: emptySearchFiltersAndResults(filters),
        aggregations: emptySearchFiltersAndResults({}),
        generateFilterFromData: emptySearchFiltersAndResults({}),
    };
}

export type DoTheSearchingProps = {
    children: React.ReactNode
}

export function DoTheSearching({ children }: DoTheSearchingProps) {
    useDoSearch<AllSearchTypes, any, any, any, any>("immediate", filters => ({ source: "query", page: "advanced", searchType: "immediate", query: filters[searchTextName], role: "unknown" }));
    useDoSearch<AllSearchTypes, any, any, any, any>("submit", filters => ({ source: "query", page: "advanced", searchType: "submit", query: filters[searchTextName], role: "unknown" }));
    useDoSearch<AllSearchTypes, any, any, any, any>("aggregations");



    useDataForFilters<AllSearchTypes, any, any, any, any>("generateFilterFromData");
    const filterPlugIns = useFilterPlugins();
    const [guiFilters, setGuiFilters] = useGuiFilters();
    const trigger = useTriggerSearch<any>();
    const debug = useDebug(searchDebugName);
    const dataView = useSelectedDataView();

    const thatCauseSubmit = useMemo(() => filterValuesThatCauseSubmit(filterPlugIns, guiFilters), [guiFilters]);
    useEffect(() => { //when we change some of the filters we want to trigger an auto submit
        debug("triggering submit", thatCauseSubmit, guiFilters);
        trigger("submit", guiFilters);
    }, [JSON.stringify(thatCauseSubmit)]);

    useEffect(() => { //when we change data views we have work to do
        const changeView = dataView.changeView;
        let filtersForTrigger: any = guiFilters;
        if (changeView.cleanWhenSelectView) {
            const cleanedGuiFilters = cleanFilters({ ...guiFilters, [searchTextName]: guiFilters?.[searchTextName] || "" }, filterPlugIns);
            debug("DoTheSearching changeView: setting guiFilter", changeView, guiFilters, filtersForTrigger);
            setGuiFilters(cleanedGuiFilters);
            filtersForTrigger = cleanedGuiFilters;
        }
        if (changeView.forceSearchWhenSelectView) {
            trigger(submitSearch, filtersForTrigger);
            trigger(immediateSearch, filtersForTrigger);
        }
    }, [dataView]);

    return <>{children}</>;
}


